import * as Types from '../../types/bff/gql-schema';

import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const PreSignedUrlForReceiptUploadDocument = `
    query PreSignedUrlForReceiptUpload($request: ReceiptUploadPreSignedUrlRequestInput!) {
  preSignedUrlForReceiptUpload(request: $request) {
    preSignedUrl
    filePath
  }
}
    `;
export const usePreSignedUrlForReceiptUploadQuery = <
      TData = Types.PreSignedUrlForReceiptUploadQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.PreSignedUrlForReceiptUploadQueryVariables,
      options?: UseQueryOptions<Types.PreSignedUrlForReceiptUploadQuery, TError, TData>,
    ) =>
    useQuery<Types.PreSignedUrlForReceiptUploadQuery, TError, TData>(
      ['PreSignedUrlForReceiptUpload', variables],
      gqlFetcher<Types.PreSignedUrlForReceiptUploadQuery, Types.PreSignedUrlForReceiptUploadQueryVariables>(PreSignedUrlForReceiptUploadDocument, 'PreSignedUrlForReceiptUpload', variables),
      options
    );

usePreSignedUrlForReceiptUploadQuery.getKey = (variables: Types.PreSignedUrlForReceiptUploadQueryVariables) => ['PreSignedUrlForReceiptUpload', variables];
;

usePreSignedUrlForReceiptUploadQuery.fetcher = (variables: Types.PreSignedUrlForReceiptUploadQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.PreSignedUrlForReceiptUploadQuery, Types.PreSignedUrlForReceiptUploadQueryVariables>(PreSignedUrlForReceiptUploadDocument, 'PreSignedUrlForReceiptUpload', variables, options);
export const ParseReceiptDocument = `
    mutation ParseReceipt($request: ReceiptParsingRequestInput!) {
  parseReceipt(request: $request) {
    success
    storeInformation {
      name
      address
      businessNumber
    }
    paymentInformation {
      price
      paidDate
      cardCompany
      cardNumber
    }
  }
}
    `;
export const useParseReceiptMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.ParseReceiptMutation, TError, Types.ParseReceiptMutationVariables, TContext>) =>
    useMutation<Types.ParseReceiptMutation, TError, Types.ParseReceiptMutationVariables, TContext>(
      ['ParseReceipt'],
      (variables?: Types.ParseReceiptMutationVariables) => gqlFetcher<Types.ParseReceiptMutation, Types.ParseReceiptMutationVariables>(ParseReceiptDocument, 'ParseReceipt', variables)(),
      options
    );
useParseReceiptMutation.fetcher = (variables: Types.ParseReceiptMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.ParseReceiptMutation, Types.ParseReceiptMutationVariables>(ParseReceiptDocument, 'ParseReceipt', variables, options);
export const PharmacyReviewTagsByRatingDocument = `
    query PharmacyReviewTagsByRating($rating: Int!) {
  pharmacyReviewTagsByRating(rating: $rating) {
    id
    text
  }
}
    `;
export const usePharmacyReviewTagsByRatingQuery = <
      TData = Types.PharmacyReviewTagsByRatingQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.PharmacyReviewTagsByRatingQueryVariables,
      options?: UseQueryOptions<Types.PharmacyReviewTagsByRatingQuery, TError, TData>,
    ) =>
    useQuery<Types.PharmacyReviewTagsByRatingQuery, TError, TData>(
      ['PharmacyReviewTagsByRating', variables],
      gqlFetcher<Types.PharmacyReviewTagsByRatingQuery, Types.PharmacyReviewTagsByRatingQueryVariables>(PharmacyReviewTagsByRatingDocument, 'PharmacyReviewTagsByRating', variables),
      options
    );

usePharmacyReviewTagsByRatingQuery.getKey = (variables: Types.PharmacyReviewTagsByRatingQueryVariables) => ['PharmacyReviewTagsByRating', variables];
;

usePharmacyReviewTagsByRatingQuery.fetcher = (variables: Types.PharmacyReviewTagsByRatingQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.PharmacyReviewTagsByRatingQuery, Types.PharmacyReviewTagsByRatingQueryVariables>(PharmacyReviewTagsByRatingDocument, 'PharmacyReviewTagsByRating', variables, options);
export const CreatePharmacyReviewV2Document = `
    mutation CreatePharmacyReviewV2($request: PharmacyReviewCreateMutationRequestInput!) {
  createPharmacyReviewV2(request: $request)
}
    `;
export const useCreatePharmacyReviewV2Mutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.CreatePharmacyReviewV2Mutation, TError, Types.CreatePharmacyReviewV2MutationVariables, TContext>) =>
    useMutation<Types.CreatePharmacyReviewV2Mutation, TError, Types.CreatePharmacyReviewV2MutationVariables, TContext>(
      ['CreatePharmacyReviewV2'],
      (variables?: Types.CreatePharmacyReviewV2MutationVariables) => gqlFetcher<Types.CreatePharmacyReviewV2Mutation, Types.CreatePharmacyReviewV2MutationVariables>(CreatePharmacyReviewV2Document, 'CreatePharmacyReviewV2', variables)(),
      options
    );
useCreatePharmacyReviewV2Mutation.fetcher = (variables: Types.CreatePharmacyReviewV2MutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.CreatePharmacyReviewV2Mutation, Types.CreatePharmacyReviewV2MutationVariables>(CreatePharmacyReviewV2Document, 'CreatePharmacyReviewV2', variables, options);
export const RequestPartnershipPickupDispensationV2Document = `
    mutation requestPartnershipPickupDispensationV2($request: PartnershipPickupDispensationMutationRequestV2Input!) {
  requestPartnershipPickupDispensationV2(request: $request)
}
    `;
export const useRequestPartnershipPickupDispensationV2Mutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.RequestPartnershipPickupDispensationV2Mutation, TError, Types.RequestPartnershipPickupDispensationV2MutationVariables, TContext>) =>
    useMutation<Types.RequestPartnershipPickupDispensationV2Mutation, TError, Types.RequestPartnershipPickupDispensationV2MutationVariables, TContext>(
      ['requestPartnershipPickupDispensationV2'],
      (variables?: Types.RequestPartnershipPickupDispensationV2MutationVariables) => gqlFetcher<Types.RequestPartnershipPickupDispensationV2Mutation, Types.RequestPartnershipPickupDispensationV2MutationVariables>(RequestPartnershipPickupDispensationV2Document, 'requestPartnershipPickupDispensationV2', variables)(),
      options
    );
useRequestPartnershipPickupDispensationV2Mutation.fetcher = (variables: Types.RequestPartnershipPickupDispensationV2MutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.RequestPartnershipPickupDispensationV2Mutation, Types.RequestPartnershipPickupDispensationV2MutationVariables>(RequestPartnershipPickupDispensationV2Document, 'requestPartnershipPickupDispensationV2', variables, options);
export const PharmacyReviewsDocument = `
    query PharmacyReviews($request: PharmacyReviewRequestInput!) {
  pharmacyReviews(request: $request) {
    content
    createdAt
    id
    isPrivate
    maskedHolderName
    rating
    targetCategoryName
    targetPrice
    title
    reviewContext {
      reviewHolderId
    }
    reviewTags {
      reviewId
      tag {
        tagId
        text
      }
    }
  }
}
    `;
export const usePharmacyReviewsQuery = <
      TData = Types.PharmacyReviewsQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.PharmacyReviewsQueryVariables,
      options?: UseQueryOptions<Types.PharmacyReviewsQuery, TError, TData>,
    ) =>
    useQuery<Types.PharmacyReviewsQuery, TError, TData>(
      ['PharmacyReviews', variables],
      gqlFetcher<Types.PharmacyReviewsQuery, Types.PharmacyReviewsQueryVariables>(PharmacyReviewsDocument, 'PharmacyReviews', variables),
      options
    );

usePharmacyReviewsQuery.getKey = (variables: Types.PharmacyReviewsQueryVariables) => ['PharmacyReviews', variables];
;

usePharmacyReviewsQuery.fetcher = (variables: Types.PharmacyReviewsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.PharmacyReviewsQuery, Types.PharmacyReviewsQueryVariables>(PharmacyReviewsDocument, 'PharmacyReviews', variables, options);
export const PickupNearbyPharmacySearchTabDocument = `
    query PickupNearbyPharmacySearchTab($diagnosisId: ID!) {
  pickupNearbyPharmacySearchTab(diagnosisId: $diagnosisId) {
    sortTypes {
      type
      title
    }
    filters {
      type
      title
      description
      mode
      activeIconUrl
      inactiveIconUrl
      subFilters {
        type
        title
        description
        mode
        inactiveIconUrl
        activeIconUrl
      }
    }
  }
}
    `;
export const usePickupNearbyPharmacySearchTabQuery = <
      TData = Types.PickupNearbyPharmacySearchTabQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.PickupNearbyPharmacySearchTabQueryVariables,
      options?: UseQueryOptions<Types.PickupNearbyPharmacySearchTabQuery, TError, TData>,
    ) =>
    useQuery<Types.PickupNearbyPharmacySearchTabQuery, TError, TData>(
      ['PickupNearbyPharmacySearchTab', variables],
      gqlFetcher<Types.PickupNearbyPharmacySearchTabQuery, Types.PickupNearbyPharmacySearchTabQueryVariables>(PickupNearbyPharmacySearchTabDocument, 'PickupNearbyPharmacySearchTab', variables),
      options
    );

usePickupNearbyPharmacySearchTabQuery.getKey = (variables: Types.PickupNearbyPharmacySearchTabQueryVariables) => ['PickupNearbyPharmacySearchTab', variables];
;

usePickupNearbyPharmacySearchTabQuery.fetcher = (variables: Types.PickupNearbyPharmacySearchTabQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.PickupNearbyPharmacySearchTabQuery, Types.PickupNearbyPharmacySearchTabQueryVariables>(PickupNearbyPharmacySearchTabDocument, 'PickupNearbyPharmacySearchTab', variables, options);
export const GeneralNearbyPharmacySearchTabsDocument = `
    query GeneralNearbyPharmacySearchTabs {
  generalNearbyPharmacySearchTabs {
    id
    name
    diagnosisType
    diagnosisTypeId
    sortTypes {
      type
      title
    }
    filters {
      type
      title
      description
      mode
      activeIconUrl
      inactiveIconUrl
      subFilters {
        type
        title
        description
        mode
        inactiveIconUrl
        activeIconUrl
      }
    }
    treatmentMedicines {
      id
      treatmentId
      name
      description
      dispensationUnits {
        isDefault
        dispensationUnit
        dispensationUnitDisplayName
        treatmentMedicineId
        treatmentMedicineUnitId
      }
      treatmentMedicineStrengths {
        treatmentMedicineStrengthId
        unit
        treatmentMedicineId
        isDefault
      }
    }
  }
}
    `;
export const useGeneralNearbyPharmacySearchTabsQuery = <
      TData = Types.GeneralNearbyPharmacySearchTabsQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.GeneralNearbyPharmacySearchTabsQueryVariables,
      options?: UseQueryOptions<Types.GeneralNearbyPharmacySearchTabsQuery, TError, TData>,
    ) =>
    useQuery<Types.GeneralNearbyPharmacySearchTabsQuery, TError, TData>(
      variables === undefined ? ['GeneralNearbyPharmacySearchTabs'] : ['GeneralNearbyPharmacySearchTabs', variables],
      gqlFetcher<Types.GeneralNearbyPharmacySearchTabsQuery, Types.GeneralNearbyPharmacySearchTabsQueryVariables>(GeneralNearbyPharmacySearchTabsDocument, 'GeneralNearbyPharmacySearchTabs', variables),
      options
    );

useGeneralNearbyPharmacySearchTabsQuery.getKey = (variables?: Types.GeneralNearbyPharmacySearchTabsQueryVariables) => variables === undefined ? ['GeneralNearbyPharmacySearchTabs'] : ['GeneralNearbyPharmacySearchTabs', variables];
;

useGeneralNearbyPharmacySearchTabsQuery.fetcher = (variables?: Types.GeneralNearbyPharmacySearchTabsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GeneralNearbyPharmacySearchTabsQuery, Types.GeneralNearbyPharmacySearchTabsQueryVariables>(GeneralNearbyPharmacySearchTabsDocument, 'GeneralNearbyPharmacySearchTabs', variables, options);
export const TreatmentMedicinesByTreatmentIdDocument = `
    query TreatmentMedicinesByTreatmentId($treatmentId: ID!) {
  treatmentMedicinesByTreatmentId(treatmentId: $treatmentId) {
    id
    treatmentId
    name
    description
    dispensationUnits {
      isDefault
      dispensationUnit
      dispensationUnitDisplayName
      treatmentMedicineId
      treatmentMedicineUnitId
    }
  }
}
    `;
export const useTreatmentMedicinesByTreatmentIdQuery = <
      TData = Types.TreatmentMedicinesByTreatmentIdQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.TreatmentMedicinesByTreatmentIdQueryVariables,
      options?: UseQueryOptions<Types.TreatmentMedicinesByTreatmentIdQuery, TError, TData>,
    ) =>
    useQuery<Types.TreatmentMedicinesByTreatmentIdQuery, TError, TData>(
      ['TreatmentMedicinesByTreatmentId', variables],
      gqlFetcher<Types.TreatmentMedicinesByTreatmentIdQuery, Types.TreatmentMedicinesByTreatmentIdQueryVariables>(TreatmentMedicinesByTreatmentIdDocument, 'TreatmentMedicinesByTreatmentId', variables),
      options
    );

useTreatmentMedicinesByTreatmentIdQuery.getKey = (variables: Types.TreatmentMedicinesByTreatmentIdQueryVariables) => ['TreatmentMedicinesByTreatmentId', variables];
;

useTreatmentMedicinesByTreatmentIdQuery.fetcher = (variables: Types.TreatmentMedicinesByTreatmentIdQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.TreatmentMedicinesByTreatmentIdQuery, Types.TreatmentMedicinesByTreatmentIdQueryVariables>(TreatmentMedicinesByTreatmentIdDocument, 'TreatmentMedicinesByTreatmentId', variables, options);
export const GetPharmacyDispensableMedicinesDocument = `
    query GetPharmacyDispensableMedicines($request: PharmacyDispensableMedicinesRequestInput!) {
  pharmacyDispensableMedicines(request: $request) {
    totalAmount
    dispensableMedicines {
      prescribedMedicineId
      pharmacyMedicine {
        medicineId
        price
        isAlternativeMedicine
        unitType
        unit
        displayName
        medicine {
          medicineName
        }
        treatmentMedicine {
          name
        }
      }
    }
  }
}
    `;
export const useGetPharmacyDispensableMedicinesQuery = <
      TData = Types.GetPharmacyDispensableMedicinesQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetPharmacyDispensableMedicinesQueryVariables,
      options?: UseQueryOptions<Types.GetPharmacyDispensableMedicinesQuery, TError, TData>,
    ) =>
    useQuery<Types.GetPharmacyDispensableMedicinesQuery, TError, TData>(
      ['GetPharmacyDispensableMedicines', variables],
      gqlFetcher<Types.GetPharmacyDispensableMedicinesQuery, Types.GetPharmacyDispensableMedicinesQueryVariables>(GetPharmacyDispensableMedicinesDocument, 'GetPharmacyDispensableMedicines', variables),
      options
    );

useGetPharmacyDispensableMedicinesQuery.getKey = (variables: Types.GetPharmacyDispensableMedicinesQueryVariables) => ['GetPharmacyDispensableMedicines', variables];
;

useGetPharmacyDispensableMedicinesQuery.fetcher = (variables: Types.GetPharmacyDispensableMedicinesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetPharmacyDispensableMedicinesQuery, Types.GetPharmacyDispensableMedicinesQueryVariables>(GetPharmacyDispensableMedicinesDocument, 'GetPharmacyDispensableMedicines', variables, options);
export const FindGeneralListOfNearbyPharmacyV3ByUserDocument = `
    query FindGeneralListOfNearbyPharmacyV3ByUser($request: NearbyPharmacySearchRequestV3Input!, $treatmentId: ID = null, $treatmentMedicineId: ID = null, $treatmentMedicineStrengthId: ID = null, $dispensationUnit: Int = null, $shouldIncludeDispensableMedicine: Boolean! = false, $shouldIncludeDiagnosisPrice: Boolean! = false) {
  nearbyPharmacyV3ByUser(request: $request) {
    contact {
      tel
      safetyNumber
    }
    location {
      distanceInMeters
      latitude
      longitude
      pharmacyName
      roadAddress
      jibunAddress
      detailAddress
    }
    name
    partnership
    pharmacyId
    publicId
    pickupCompletedCount
    reviewMeta {
      averageRating
      totalCount
    }
    attributesV3(
      diagnosisId: null
      treatmentMedicineId: $treatmentMedicineId
      treatmentMedicineStrengthId: $treatmentMedicineStrengthId
      isAlternativeExcluded: null
      dispensationUnit: $dispensationUnit
    ) {
      mainTags {
        title
        type
        imageUrl
      }
      badges {
        title
        type
        imageUrl
      }
      tags {
        title
        type
        imageUrl
      }
      priceTags {
        title
        type
        imageUrl
      }
    }
    dispensableMedicines(
      diagnosisId: null
      treatmentMedicineId: $treatmentMedicineId
      treatmentMedicineStrengthId: $treatmentMedicineStrengthId
      dispensationUnit: $dispensationUnit
      isAlternativeExcluded: false
    ) @include(if: $shouldIncludeDispensableMedicine) {
      totalAmount
      dispensableMedicines {
        pharmacyMedicine {
          medicineId
          price
          isAlternativeMedicine
          unitType
          unit
          displayName
          medicine {
            medicineName
          }
          treatmentMedicine {
            name
          }
        }
      }
    }
    diagnosisPrice(
      treatmentId: $treatmentId
      treatmentMedicineId: $treatmentMedicineId
    ) @include(if: $shouldIncludeDiagnosisPrice)
    operation {
      status
      display
    }
    pharmacyNextOperationHour {
      earliestAvailableReservationHour
      earliestAvailableReservationHourString
    }
    isFavoritePharmacy
  }
}
    `;
export const useFindGeneralListOfNearbyPharmacyV3ByUserQuery = <
      TData = Types.FindGeneralListOfNearbyPharmacyV3ByUserQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.FindGeneralListOfNearbyPharmacyV3ByUserQueryVariables,
      options?: UseQueryOptions<Types.FindGeneralListOfNearbyPharmacyV3ByUserQuery, TError, TData>,
    ) =>
    useQuery<Types.FindGeneralListOfNearbyPharmacyV3ByUserQuery, TError, TData>(
      ['FindGeneralListOfNearbyPharmacyV3ByUser', variables],
      gqlFetcher<Types.FindGeneralListOfNearbyPharmacyV3ByUserQuery, Types.FindGeneralListOfNearbyPharmacyV3ByUserQueryVariables>(FindGeneralListOfNearbyPharmacyV3ByUserDocument, 'FindGeneralListOfNearbyPharmacyV3ByUser', variables),
      options
    );

useFindGeneralListOfNearbyPharmacyV3ByUserQuery.getKey = (variables: Types.FindGeneralListOfNearbyPharmacyV3ByUserQueryVariables) => ['FindGeneralListOfNearbyPharmacyV3ByUser', variables];
;

useFindGeneralListOfNearbyPharmacyV3ByUserQuery.fetcher = (variables: Types.FindGeneralListOfNearbyPharmacyV3ByUserQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.FindGeneralListOfNearbyPharmacyV3ByUserQuery, Types.FindGeneralListOfNearbyPharmacyV3ByUserQueryVariables>(FindGeneralListOfNearbyPharmacyV3ByUserDocument, 'FindGeneralListOfNearbyPharmacyV3ByUser', variables, options);
export const FindPickupListOfNearbyPharmacyV3ByUserDocument = `
    query FindPickupListOfNearbyPharmacyV3ByUser($request: NearbyPharmacySearchRequestV3Input!, $userLocation: NearbyPharmacyGeoPointInput!, $diagnosisId: ID = null, $shouldIncludeDispensableMedicine: Boolean = false, $isAlternativeExcluded: Boolean!) {
  nearbyPharmacyV3ByUser(request: $request) {
    contact {
      faxNumber
      safetyNumber
      tel
    }
    location {
      distanceInMeters
      latitude
      longitude
      pharmacyName
      roadAddress
      jibunAddress
      detailAddress
    }
    name
    partnership
    pharmacyId
    publicId
    pickupCompletedCount
    reviewMeta {
      averageRating
      totalCount
    }
    attributesV3(
      diagnosisId: $diagnosisId
      isAlternativeExcluded: $isAlternativeExcluded
    ) {
      mainTags {
        title
        type
        imageUrl
      }
      badges {
        title
        type
        imageUrl
      }
      tags {
        title
        type
        imageUrl
      }
      priceTags {
        title
        type
        imageUrl
      }
      recommendationScore(diagnosisId: $diagnosisId, userLocation: $userLocation) {
        pharmacyId
        score
      }
    }
    dispensableMedicines(
      diagnosisId: $diagnosisId
      treatmentMedicineId: null
      dispensationUnit: null
      isAlternativeExcluded: $isAlternativeExcluded
    ) @include(if: $shouldIncludeDispensableMedicine) {
      totalAmount
      dispensableMedicines {
        pharmacyMedicine {
          medicineId
          price
          isAlternativeMedicine
          unitType
          unit
          displayName
          medicine {
            medicineName
          }
          treatmentMedicine {
            name
          }
        }
        medicine {
          medicineName
        }
      }
    }
    operation {
      status
      display
    }
    pharmacyNextOperationHour {
      earliestAvailableReservationHour
      earliestAvailableReservationHourString
    }
    isFavoritePharmacy
  }
}
    `;
export const useFindPickupListOfNearbyPharmacyV3ByUserQuery = <
      TData = Types.FindPickupListOfNearbyPharmacyV3ByUserQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.FindPickupListOfNearbyPharmacyV3ByUserQueryVariables,
      options?: UseQueryOptions<Types.FindPickupListOfNearbyPharmacyV3ByUserQuery, TError, TData>,
    ) =>
    useQuery<Types.FindPickupListOfNearbyPharmacyV3ByUserQuery, TError, TData>(
      ['FindPickupListOfNearbyPharmacyV3ByUser', variables],
      gqlFetcher<Types.FindPickupListOfNearbyPharmacyV3ByUserQuery, Types.FindPickupListOfNearbyPharmacyV3ByUserQueryVariables>(FindPickupListOfNearbyPharmacyV3ByUserDocument, 'FindPickupListOfNearbyPharmacyV3ByUser', variables),
      options
    );

useFindPickupListOfNearbyPharmacyV3ByUserQuery.getKey = (variables: Types.FindPickupListOfNearbyPharmacyV3ByUserQueryVariables) => ['FindPickupListOfNearbyPharmacyV3ByUser', variables];
;

useFindPickupListOfNearbyPharmacyV3ByUserQuery.fetcher = (variables: Types.FindPickupListOfNearbyPharmacyV3ByUserQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.FindPickupListOfNearbyPharmacyV3ByUserQuery, Types.FindPickupListOfNearbyPharmacyV3ByUserQueryVariables>(FindPickupListOfNearbyPharmacyV3ByUserDocument, 'FindPickupListOfNearbyPharmacyV3ByUser', variables, options);
export const GetNearbyPharmacyDetailV3ByUserDocument = `
    query GetNearbyPharmacyDetailV3ByUser($request: NearbyPharmacyDetailSearchByPublicIdRequestInput!, $diagnosisId: ID, $isAlternativeExcluded: Boolean!) {
  nearbyPharmacyDetailByPublicId(request: $request) {
    contact {
      faxNumber
      tel
      safetyNumber
    }
    location {
      detailAddress
      distanceInMeters
      jibunAddress
      latitude
      longitude
      pharmacyName
      roadAddress
      zipCode
      parkingType {
        name
        type
      }
      parkingDescription
      directions
    }
    partnership
    pharmacyId
    publicId
    pickupCompletedCount
    reviewMeta {
      totalCount
      averageRating
    }
    pharmacyNextOperationHour {
      earliestAvailableReservationHour
      earliestAvailableReservationHourString
    }
    operation {
      display
      todayDuty {
        weekDay
        openTime
        closeTime
        isClosed
        hasBreakTime
        breakStartTime
        breakEndTime
      }
      duties {
        weekDay
        openTime
        closeTime
        isClosed
        hasBreakTime
        breakStartTime
        breakEndTime
      }
      status
    }
    numberOfReviewsByRating {
      rating
      count
    }
    attributesV3(
      diagnosisId: $diagnosisId
      isAlternativeExcluded: $isAlternativeExcluded
    ) {
      mainTags {
        imageUrl
        type
      }
      badges {
        imageUrl
        type
      }
      tags {
        imageUrl
        type
      }
      priceTags {
        title
        type
        imageUrl
      }
    }
    prescribedMedicineInfoWithDoseDays(diagnosisId: $diagnosisId) {
      medicineSummary {
        medicineId
        medicineName
        medicineImageUrl
        hasDetailInfo
        pharmaceuticalEffectLiteracy
        publicId
        medicineDispensability(isAlternativeExcluded: $isAlternativeExcluded) {
          medicineId
          dispensabilityStatus
          iconImageUrl
        }
      }
    }
    isFavoritePharmacy
  }
}
    `;
export const useGetNearbyPharmacyDetailV3ByUserQuery = <
      TData = Types.GetNearbyPharmacyDetailV3ByUserQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetNearbyPharmacyDetailV3ByUserQueryVariables,
      options?: UseQueryOptions<Types.GetNearbyPharmacyDetailV3ByUserQuery, TError, TData>,
    ) =>
    useQuery<Types.GetNearbyPharmacyDetailV3ByUserQuery, TError, TData>(
      ['GetNearbyPharmacyDetailV3ByUser', variables],
      gqlFetcher<Types.GetNearbyPharmacyDetailV3ByUserQuery, Types.GetNearbyPharmacyDetailV3ByUserQueryVariables>(GetNearbyPharmacyDetailV3ByUserDocument, 'GetNearbyPharmacyDetailV3ByUser', variables),
      options
    );

useGetNearbyPharmacyDetailV3ByUserQuery.getKey = (variables: Types.GetNearbyPharmacyDetailV3ByUserQueryVariables) => ['GetNearbyPharmacyDetailV3ByUser', variables];
;

useGetNearbyPharmacyDetailV3ByUserQuery.fetcher = (variables: Types.GetNearbyPharmacyDetailV3ByUserQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetNearbyPharmacyDetailV3ByUserQuery, Types.GetNearbyPharmacyDetailV3ByUserQueryVariables>(GetNearbyPharmacyDetailV3ByUserDocument, 'GetNearbyPharmacyDetailV3ByUser', variables, options);
export const AddFavoritePharmacyDocument = `
    mutation AddFavoritePharmacy($pharmacyId: ID!) {
  addFavoritePharmacy(pharmacyId: $pharmacyId)
}
    `;
export const useAddFavoritePharmacyMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.AddFavoritePharmacyMutation, TError, Types.AddFavoritePharmacyMutationVariables, TContext>) =>
    useMutation<Types.AddFavoritePharmacyMutation, TError, Types.AddFavoritePharmacyMutationVariables, TContext>(
      ['AddFavoritePharmacy'],
      (variables?: Types.AddFavoritePharmacyMutationVariables) => gqlFetcher<Types.AddFavoritePharmacyMutation, Types.AddFavoritePharmacyMutationVariables>(AddFavoritePharmacyDocument, 'AddFavoritePharmacy', variables)(),
      options
    );
useAddFavoritePharmacyMutation.fetcher = (variables: Types.AddFavoritePharmacyMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.AddFavoritePharmacyMutation, Types.AddFavoritePharmacyMutationVariables>(AddFavoritePharmacyDocument, 'AddFavoritePharmacy', variables, options);
export const RemoveFavoritePharmacyDocument = `
    mutation RemoveFavoritePharmacy($pharmacyId: ID!) {
  removeFavoritePharmacy(pharmacyId: $pharmacyId)
}
    `;
export const useRemoveFavoritePharmacyMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.RemoveFavoritePharmacyMutation, TError, Types.RemoveFavoritePharmacyMutationVariables, TContext>) =>
    useMutation<Types.RemoveFavoritePharmacyMutation, TError, Types.RemoveFavoritePharmacyMutationVariables, TContext>(
      ['RemoveFavoritePharmacy'],
      (variables?: Types.RemoveFavoritePharmacyMutationVariables) => gqlFetcher<Types.RemoveFavoritePharmacyMutation, Types.RemoveFavoritePharmacyMutationVariables>(RemoveFavoritePharmacyDocument, 'RemoveFavoritePharmacy', variables)(),
      options
    );
useRemoveFavoritePharmacyMutation.fetcher = (variables: Types.RemoveFavoritePharmacyMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.RemoveFavoritePharmacyMutation, Types.RemoveFavoritePharmacyMutationVariables>(RemoveFavoritePharmacyDocument, 'RemoveFavoritePharmacy', variables, options);
export const CheckUserFavoritePharmacyDocument = `
    query CheckUserFavoritePharmacy($pharmacyId: ID!) {
  checkUserFavoritePharmacy(pharmacyId: $pharmacyId)
}
    `;
export const useCheckUserFavoritePharmacyQuery = <
      TData = Types.CheckUserFavoritePharmacyQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.CheckUserFavoritePharmacyQueryVariables,
      options?: UseQueryOptions<Types.CheckUserFavoritePharmacyQuery, TError, TData>,
    ) =>
    useQuery<Types.CheckUserFavoritePharmacyQuery, TError, TData>(
      ['CheckUserFavoritePharmacy', variables],
      gqlFetcher<Types.CheckUserFavoritePharmacyQuery, Types.CheckUserFavoritePharmacyQueryVariables>(CheckUserFavoritePharmacyDocument, 'CheckUserFavoritePharmacy', variables),
      options
    );

useCheckUserFavoritePharmacyQuery.getKey = (variables: Types.CheckUserFavoritePharmacyQueryVariables) => ['CheckUserFavoritePharmacy', variables];
;

useCheckUserFavoritePharmacyQuery.fetcher = (variables: Types.CheckUserFavoritePharmacyQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.CheckUserFavoritePharmacyQuery, Types.CheckUserFavoritePharmacyQueryVariables>(CheckUserFavoritePharmacyDocument, 'CheckUserFavoritePharmacy', variables, options);
export const GetPharmacyAttributesDocument = `
    query GetPharmacyAttributes($request: NearbyPharmacyDetailSearchRequestV3Input!, $diagnosisId: ID!, $isAlternativeExcluded: Boolean!) {
  nearbyPharmacyDetailV3ByUser(request: $request) {
    attributesV3(
      diagnosisId: $diagnosisId
      isAlternativeExcluded: $isAlternativeExcluded
    ) {
      mainTags {
        title
        type
        imageUrl
      }
      badges {
        title
        type
        imageUrl
      }
      tags {
        title
        type
        imageUrl
      }
      priceTags {
        title
        type
        imageUrl
      }
    }
  }
}
    `;
export const useGetPharmacyAttributesQuery = <
      TData = Types.GetPharmacyAttributesQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetPharmacyAttributesQueryVariables,
      options?: UseQueryOptions<Types.GetPharmacyAttributesQuery, TError, TData>,
    ) =>
    useQuery<Types.GetPharmacyAttributesQuery, TError, TData>(
      ['GetPharmacyAttributes', variables],
      gqlFetcher<Types.GetPharmacyAttributesQuery, Types.GetPharmacyAttributesQueryVariables>(GetPharmacyAttributesDocument, 'GetPharmacyAttributes', variables),
      options
    );

useGetPharmacyAttributesQuery.getKey = (variables: Types.GetPharmacyAttributesQueryVariables) => ['GetPharmacyAttributes', variables];
;

useGetPharmacyAttributesQuery.fetcher = (variables: Types.GetPharmacyAttributesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetPharmacyAttributesQuery, Types.GetPharmacyAttributesQueryVariables>(GetPharmacyAttributesDocument, 'GetPharmacyAttributes', variables, options);
export const RequestDispensationToPharmacyDocument = `
    mutation RequestDispensationToPharmacy($request: DispensationPharmacyFaxRequestInput!) {
  requestDispensationToPharmacy(request: $request)
}
    `;
export const useRequestDispensationToPharmacyMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.RequestDispensationToPharmacyMutation, TError, Types.RequestDispensationToPharmacyMutationVariables, TContext>) =>
    useMutation<Types.RequestDispensationToPharmacyMutation, TError, Types.RequestDispensationToPharmacyMutationVariables, TContext>(
      ['RequestDispensationToPharmacy'],
      (variables?: Types.RequestDispensationToPharmacyMutationVariables) => gqlFetcher<Types.RequestDispensationToPharmacyMutation, Types.RequestDispensationToPharmacyMutationVariables>(RequestDispensationToPharmacyDocument, 'RequestDispensationToPharmacy', variables)(),
      options
    );
useRequestDispensationToPharmacyMutation.fetcher = (variables: Types.RequestDispensationToPharmacyMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.RequestDispensationToPharmacyMutation, Types.RequestDispensationToPharmacyMutationVariables>(RequestDispensationToPharmacyDocument, 'RequestDispensationToPharmacy', variables, options);
export const FavoritePharmaciesDocument = `
    query FavoritePharmacies($request: FavoritePharmaciesRequestInput!) {
  favoritePharmacies(request: $request) {
    name
    partnership
    pharmacyId
    publicId
    pickupCompletedCount
    isFavoritePharmacy
    contact {
      faxNumber
      safetyNumber
      tel
    }
    location {
      detailAddress
      distanceInMeters
      jibunAddress
      latitude
      longitude
      pharmacyName
      roadAddress
      zipCode
    }
    reviewMeta {
      averageRating
      totalCount
    }
    attributesV3 {
      badges {
        imageUrl
        title
        type
      }
      mainTags {
        imageUrl
        title
        type
      }
      priceTags {
        imageUrl
        title
        type
      }
      tags {
        imageUrl
        title
        type
      }
    }
    numberOfReviewsByRating {
      count
      rating
    }
    operation {
      display
      status
      duties {
        closeTime
        id
        isClosed
        openTime
        pharmacyId
        weekDay
      }
    }
    pharmacyNextOperationHour {
      earliestAvailableReservationHour
      earliestAvailableReservationHourString
      pharmacyId
    }
  }
}
    `;
export const useFavoritePharmaciesQuery = <
      TData = Types.FavoritePharmaciesQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.FavoritePharmaciesQueryVariables,
      options?: UseQueryOptions<Types.FavoritePharmaciesQuery, TError, TData>,
    ) =>
    useQuery<Types.FavoritePharmaciesQuery, TError, TData>(
      ['FavoritePharmacies', variables],
      gqlFetcher<Types.FavoritePharmaciesQuery, Types.FavoritePharmaciesQueryVariables>(FavoritePharmaciesDocument, 'FavoritePharmacies', variables),
      options
    );

useFavoritePharmaciesQuery.getKey = (variables: Types.FavoritePharmaciesQueryVariables) => ['FavoritePharmacies', variables];
;

useFavoritePharmaciesQuery.fetcher = (variables: Types.FavoritePharmaciesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.FavoritePharmaciesQuery, Types.FavoritePharmaciesQueryVariables>(FavoritePharmaciesDocument, 'FavoritePharmacies', variables, options);